export class BrowserService {

    canFullScreen = false;
    canAudioVolume = false;
    haveLocalStorage = false;
    constructor() {

        
        this.canFullScreen = document.fullscreenEnabled;

        /**
         * @type {HTMLAudioElement}
         */
        const audio = document.createElement("audio");
        const vol = audio.volume;
        audio.addEventListener("volumechange", () => {
            this.canAudioVolume = true;
        });
        audio.volume = 0;

        window.setTimeout(() => {
            if (this.canAudioVolume) {
                audio.volume = vol;
            }
            audio.remove();
        }, 100);

        this.haveLocalStorage = this.storageAvailable();

    }

    storageAvailable() {
        const storage = window.localStorage;
        try {
            const x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return e instanceof DOMException && (
                // everything except Firefox
                e.name === 'QuotaExceededError' ||
                // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                // acknowledge QuotaExceededError only if there's something already stored
                (storage && storage.length !== 0);
        }
    }

    canUseLocalStorage = ()=>{
        return this.haveLocalStorage;
    }

    canSetAudioVolume = () => {
        return this.canAudioVolume;
    }

    canSetFullScreen = () => {
        return this.canFullScreen;
    }

    havePassiveEvents = () => {
        let supportsPassiveOption = false;
        try {
          const opts = Object.defineProperty({}, 'passive', {
            get: function() {
              supportsPassiveOption = true;
              return false;
            }
          });
          window.addEventListener('test', null, opts);
          window.removeEventListener('test', null, opts);
        } catch (e:unknown) {
            console.error(e);
            return false;
        }
        return supportsPassiveOption;
    }
}

const browserService = new BrowserService();
export default browserService;